export default [
  {
    path: '/admin/mart-sales/lists',
    name: 'mart-sale-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/mart-sale/table.vue')
  },
  {
    path: '/admin/mart-sales',
    name: 'order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/mart-sale/index.vue')
  }
]
